import { fromJS, List, Map } from 'immutable';
import {
  // Project credentials page
  CHANGE_PROJECT_CREDENTIALS_CATEGORY,
  CHANGE_PROJECT_CREDENTIALS_FILTER,
  TOGGLE_PROJECT_CREDENTIALS_SIDEBAR,
  CHANGE_PROJECT_CREDENTIAL_PROJECT_ID,
  LOAD_PROJECT_CREDENTIALS_SUCCESS,
  DELETE_CREDENTIAL_SUCCESS,

  // Project service maps page
  TOGGLE_SERVICE_MAP_FORM,
  TOGGLE_SERVICE_MAP_VIEW,
  CHANGE_PROJECT_SERVICES_SEARCH,
  UPDATE_PROJECT_CREDENTIAL_SUCCESS,

  // Project tasks page
  CHANGE_PROJECT_TASKS_FILTER,
  CHANGE_PROJECT_TASKS_PROJECT_ID,
  CHANGE_PROJECT_TASKS_LABEL_ID,
  TOGGLE_PROJECT_TASKS_SIDEBAR,
  UPDATE_TASK_SUCCESS,
  CHANGE_STATUS_BAR_SEARCH,
  SET_AUTH_USER,

  // Project important pages page
  LOAD_PROJECTS_IMPORTANT_PAGES_SUCCESS,
  UPDATE_PROJECTS_IMPORTANT_PAGE_SUCCESS,
  BATCH_UPDATE_PROJECTS_IMPORTANT_PAGE_SUCCESS,

  //Project file page
  LOAD_PROJECT_FILE_LIST_SUCCESS,
  UPLOAD_ENTITY_FILE_SUCCESS,
  DELETE_FILE_SUCCESS,
} from 'constants/ActionTypes';

import { PROJECT_CREDENTIAL_LIST, PROJECT_TASK_LIST } from 'constants/SettingConstants';

const initialState = fromJS({
  serviceMaps: {
    search: null,
    view: {
      isVisible: false,
      relationId: null,
    },
    form: {
      isVisible: false,
      relationId: null,
    },
  },
  credentials: {
    sidebarCollapsed: false,
    dataset: [],
    filters: {
      filter: 'all',
      category: 'all',
      search: null,
      projectId: null,
    },
    pagination: {
      totalCount: null,
      pageCount: null,
      currentPage: null,
      perPage: null,
    },
  },
  tasks: {
    sidebarCollapsed: false,
    dataset: [],
    filters: {
      search: null,
      filter: null,
      labelId: null,
      projectId: null,
    },
    pagination: {
      totalCount: null,
      pageCount: null,
      currentPage: null,
      perPage: null,
    },
  },
  importantPages: {
    dataset: [],
    pagination: {
      totalCount: null,
      pageCount: null,
      currentPage: null,
      perPage: null,
    },
  },
  projectFiles: {
    dataset: [],
    pagination: {
      totalCount: null,
      pageCount: null,
      currentPage: null,
      perPage: null,
      counters: null,
    },
  },
});

const projectViewReducer = (state = initialState, action) => {
  let dataset;
  switch (action.type) {
    // Project credentials page
    case LOAD_PROJECT_CREDENTIALS_SUCCESS:
      dataset = action.credentials.items.map((item) => item.accessId);
      state = state.setIn(['credentials', 'dataset'], fromJS(dataset));
      return (state = state.setIn(
        ['credentials', 'pagination'],
        fromJS({
          totalCount: action.credentials._meta.totalCount,
          pageCount: action.credentials._meta.pageCount,
          currentPage: action.credentials._meta.currentPage,
          perPage: action.credentials._meta.perPage,
        }),
      ));
    case TOGGLE_PROJECT_CREDENTIALS_SIDEBAR:
      return state.setIn(['credentials', 'sidebarCollapsed'], !state.getIn(['credentials', 'sidebarCollapsed']));
    case CHANGE_STATUS_BAR_SEARCH:
      state = state.setIn(
        ['credentials', 'filters'],
        fromJS({
          category: null,
          filter: 'all',
        }),
      );
      return state.setIn(
        ['tasks', 'filters'],
        fromJS({
          filter: 'all',
          labelId: null,
        }),
      );
    case CHANGE_PROJECT_CREDENTIALS_CATEGORY: {
      let newState = state.setIn(['credentials', 'filters', 'category'], action.category);
      if (newState.getIn(['credentials', 'filters', 'projectId']) !== action.projectId) {
        newState = newState.setIn(
          ['credentials', 'filters'],
          initialState.getIn(['credentials', 'filters']).merge({
            projectId: action.projectId,
            category: action.category,
          }),
        );
      }
      return newState;
    }
    case CHANGE_PROJECT_CREDENTIALS_FILTER: {
      let newState = state
        .setIn(['credentials', 'filters', 'filter'], action.filter)
        .setIn(
          ['credentials', 'filters', 'category'],
          action.filter === 'all' ? 'all' : state.getIn(['credentials', 'filters', 'category']),
        );
      if (newState.getIn(['credentials', 'filters', 'projectId']) !== action.projectId) {
        newState = newState.setIn(
          ['credentials', 'filters'],
          initialState.getIn(['credentials', 'filters']).merge({
            projectId: action.projectId,
            filter: action.filter,
          }),
        );
      }
      return newState;
    }
    case CHANGE_PROJECT_CREDENTIAL_PROJECT_ID:
      return state.setIn(['credentials', 'filters', 'projectId'], action.projectId);
    case TOGGLE_SERVICE_MAP_FORM:
      if (state.getIn(['serviceMaps', 'form', 'isVisible'])) {
        return state.setIn(
          ['serviceMaps', 'form'],
          fromJS({
            isVisible: false,
            relationId: null,
          }),
        );
      } else {
        return state.setIn(
          ['serviceMaps', 'form'],
          fromJS({
            isVisible: true,
            relationId: action.relationId,
          }),
        );
      }

    // Project service maps page
    case TOGGLE_SERVICE_MAP_VIEW:
      if (state.getIn(['serviceMaps', 'view', 'isVisible'])) {
        return state.setIn(
          ['serviceMaps', 'view'],
          fromJS({
            isVisible: false,
            relationId: null,
          }),
        );
      } else {
        return state.setIn(
          ['serviceMaps', 'view'],
          fromJS({
            isVisible: true,
            relationId: action.relationId,
          }),
        );
      }
    case CHANGE_PROJECT_SERVICES_SEARCH:
      return state.setIn(['serviceMaps', 'search'], action.search);
    case UPDATE_PROJECT_CREDENTIAL_SUCCESS: {
      const dataset = state.getIn(['credentials', 'dataset']);
      if (!dataset.includes(action.credential.accessId)) {
        return state.setIn(
          ['credentials', 'dataset'],
          state.getIn(['credentials', 'dataset']).unshift(action.credential.accessId),
        );
      }
      return state;
    }
    // Project tasks page
    case TOGGLE_PROJECT_TASKS_SIDEBAR:
      return state.setIn(['tasks', 'sidebarCollapsed'], !state.getIn(['tasks', 'sidebarCollapsed']));
    case CHANGE_PROJECT_TASKS_PROJECT_ID:
      return state.setIn(
        ['tasks', 'filters'],
        fromJS({
          projectId: action.projectId,
        }),
      );
    case CHANGE_PROJECT_TASKS_FILTER:
      return state.setIn(
        ['tasks', 'filters'],
        fromJS({
          projectId: state.getIn(['tasks', 'filters', 'projectId']),
          ...action.filter,
        }),
      );
    case CHANGE_PROJECT_TASKS_LABEL_ID:
      return state.setIn(
        ['tasks', 'filters'],
        fromJS({
          projectId: state.getIn(['tasks', 'filters', 'projectId']),
          labelId: action.labelId,
        }),
      );
    case UPDATE_TASK_SUCCESS: {
      let newState = state;
      const dataset = state.getIn(['tasks', 'dataset']);
      if (dataset.includes(action.task.taskId)) {
        if (action.task.isInFiltration !== false) {
          if (action.task.status === 'finished') {
            return newState.setIn(
              ['tasks', 'dataset'],
              dataset.delete(dataset.indexOf(action.task.taskId)).push(action.task.taskId),
            );
          }
        }

        if (newState.getIn(['tasks', 'counters', 'status', 'all'])) {
          newState = newState.setIn(
            ['tasks', 'counters', 'status'],
            fromJS({
              all: newState.getIn(['tasks', 'counters', 'status', 'all']) - 1,
              active: newState.getIn(['tasks', 'counters', 'status', 'active']) - 1,
              finished: newState.getIn(['tasks', 'counters', 'status', 'finished']) - 1,
            }),
          );
        }

        if (newState.getIn(['tasks', 'pagination', 'totalCount'])) {
          newState = newState.setIn(
            ['tasks', 'pagination', 'totalCount'],
            newState.getIn(['tasks', 'pagination', 'totalCount']) - 1,
          );
        }

        return newState;
      } else {
        return newState.setIn(['tasks', 'dataset'], dataset.unshift(action.task.taskId));
      }
    }
    case SET_AUTH_USER: {
      let newState = state;
      if (action.user.state) {
        if (action.user.state[PROJECT_CREDENTIAL_LIST] && action.user.state[PROJECT_CREDENTIAL_LIST].filters) {
          newState = newState.setIn(
            ['credentials', 'filters'],
            fromJS(action.user.state[PROJECT_CREDENTIAL_LIST].filters),
          );
        }

        if (action.user.state[PROJECT_TASK_LIST] && action.user.state[PROJECT_TASK_LIST].filters) {
          newState = newState.setIn(['tasks', 'filters'], fromJS(action.user.state[PROJECT_TASK_LIST].filters));
        }
      }
      return newState;
    }
    case LOAD_PROJECTS_IMPORTANT_PAGES_SUCCESS:
      return state.setIn(['importantPages', 'dataset'], fromJS(action.pages.items.map((page) => page.pageId))).setIn(
        ['importantPages', 'pagination'],
        fromJS({
          totalCount: action.pages._meta.totalCount,
          pageCount: action.pages._meta.pageCount,
          currentPage: action.pages._meta.currentPage,
          perPage: action.pages._meta.perPage,
        }),
      );
    case UPDATE_PROJECTS_IMPORTANT_PAGE_SUCCESS: {
      let dataset = state.getIn(['importantPages', 'dataset']);
      if (action.pages?.length) {
        action.pages.forEach((page) => {
          if (!dataset.includes(page.pageId)) {
            dataset = dataset.unshift(page.pageId);
          }
        });
      }
      return state.setIn(['importantPages', 'dataset'], dataset);
    }
    case BATCH_UPDATE_PROJECTS_IMPORTANT_PAGE_SUCCESS: {
      if (action.values.action === 'delete') {
        return state.setIn(
          ['importantPages', 'dataset'],
          state.getIn(['importantPages', 'dataset']).filter((id) => !action.values.items.includes(id)),
        );
      }
      return state;
    }

    case LOAD_PROJECT_FILE_LIST_SUCCESS: {
      const currentPage = action.fileList._meta.currentPage;
      let currentDataset = new List();
      if (currentPage > 1) {
        currentDataset = state.getIn(['projectFiles', 'dataset']);
      }
      return state
        .setIn(
          ['projectFiles', 'dataset'],
          currentDataset.concat(fromJS(action.fileList.items.map((file) => file.fileId))),
        )
        .setIn(
          ['projectFiles', 'pagination'],
          fromJS({
            totalCount: action.fileList._meta.totalCount,
            pageCount: action.fileList._meta.pageCount,
            currentPage,
            perPage: action.fileList._meta.perPage,
            counters: action.fileList._meta.counters,
          }),
        );
    }

    case UPLOAD_ENTITY_FILE_SUCCESS: {
      if (action.response.file.projectId) {
        let counter = state.getIn(['projectFiles', 'pagination', 'counters', action.response.file.extension]);
        if (!counter) {
          counter = new Map({
            count: 1,
            size: action.response.file.rawSize,
            type: action.response.file.type,
          });
        } else {
          counter = counter
            .set('count', counter.get('count') + 1)
            .set('size', counter.get('size') + action.response.file.rawSize);
        }

        return state
          .setIn(
            ['projectFiles', 'dataset'],
            state.getIn(['projectFiles', 'dataset']).unshift(action.response.file.fileId),
          )
          .setIn(['projectFiles', 'pagination', 'counters', action.response.file.extension], counter);
      }
      return state;
    }
    case DELETE_FILE_SUCCESS: {
      let newState = state.setIn(
        ['projectFiles', 'dataset'],
        state.getIn(['projectFiles', 'dataset']).filter((fileId) => fileId !== action.fileId),
      );
      if (!action.file?.extension) {
        return newState;
      }
      let counter = newState.getIn(['projectFiles', 'pagination', 'counters', action.file.extension]);
      if (counter) {
        newState = newState.setIn(
          ['projectFiles', 'pagination', 'counters', action.file.extension],
          counter.set('count', counter.get('count') - 1).set('size', counter.get('size') - action.file.rawSize),
        );
      }
      return newState;
    }
    case DELETE_CREDENTIAL_SUCCESS:
      return state.setIn(
        ['credentials', 'dataset'],
        state.getIn(['credentials', 'dataset']).filter((accessId) => accessId !== action.accessId),
      );
    default:
      return state;
  }
};

export default projectViewReducer;
